import React, { Fragment } from "react";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import PropTypes from "prop-types";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import ControlledDialog from "../../../../components/ControlledDialog/ControlledDialog";
import { TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles(() => ({
  resize: {
    padding: 14,
  },
  label: {
    marginTop: 9,
    fontSize: 16,
    color: "#1558a2",
    fontWeight: 700,
    marginRight: 10,
  },
  actions: {
    marginTop: 20,
    display: "flex",
    justifyContent: "center",
  },
}));

const ChangeContactInfo = (props) => {
  const { handleClose, open, state, onHandleChange, onSaveClick } = props;
  const classes = useStyles();

  return (
    <Fragment>
      <ControlledDialog
        hideClose
        open={open}
        disableBackdropClick
        handleClose={() => handleClose()}
        title={
          <Fragment>
            <Tooltip title="Back">
              <IconButton onClick={() => handleClose()}>
                <ArrowBackIcon fontSize="small" color="primary" />
              </IconButton>
            </Tooltip>
            <span
              style={{
                fontSize: 18,
                color: "#1558a2",
                fontWeight: 700,
              }}
            >
              Change Contact Information
            </span>
          </Fragment>
        }
        content={
          <Fragment>
            <div>
              <div className={classes.label}>Name</div>
              <TextField
                placeholder="Name"
                variant="outlined"
                fullWidth
                name="selectedCustomerName"
                error={state.customerNameError}
                value={state.selectedCustomerName}
                onChange={(e) => onHandleChange(e)}
                InputProps={{ classes: { input: classes.resize } }}
              />
            </div>

            <div>
              <div className={classes.label}>Address 1</div>
              <TextField
                placeholder="Address1"
                variant="outlined"
                fullWidth
                name="selectedAddress1"
                error={state.address1Error}
                value={state.selectedAddress1}
                onChange={(e) => onHandleChange(e)}
                InputProps={{ classes: { input: classes.resize } }}
              />
            </div>
            <div>
              <div className={classes.label}>Address 2</div>
              <TextField
                placeholder="Address2"
                variant="outlined"
                fullWidth
                name="selectedAddress2"
                error={state.address2Error}
                value={state.selectedAddress2}
                onChange={(e) => onHandleChange(e)}
                InputProps={{ classes: { input: classes.resize } }}
              />
            </div>
            <div>
              <div className={classes.label}>Mobile</div>
              <TextField
                placeholder="Mobile"
                variant="outlined"
                fullWidth
                name="selectedMobileNo"
                error={state.mobileError}
                value={state.selectedMobileNo}
                onChange={(e) => onHandleChange(e)}
                InputProps={{ classes: { input: classes.resize } }}
              />
            </div>
            <div className={classes.actions}>
              <Button
                onClick={() => onSaveClick()}
                disabled={state.onCancelItemStatusLoading}
                style={{ width: 100 }}
                variant="contained"
                color="primary"
              >
                {state.onCancelItemStatusLoading ? (
                  <CircularProgress size={30} />
                ) : (
                  "Save"
                )}
              </Button>
              <Button
                disabled={state.onCancelItemStatusLoading}
                style={{ marginLeft: 20 }}
                onClick={() => handleClose()}
                variant="contained"
              >
                Cancel
              </Button>
            </div>
          </Fragment>
        }
      />
    </Fragment>
  );
};

ChangeContactInfo.propTypes = {
  handleClose: PropTypes.func,
  onSaveClick: PropTypes.func,
  onHandleChange: PropTypes.func,
  open: PropTypes.bool,
  state: PropTypes.object,
};

ChangeContactInfo.defaultProps = {
  handleClose: (fn) => fn,
  onSaveClick: (fn) => fn,
  onHandleChange: (fn) => fn,
  open: false,
  state: {},
};

export default ChangeContactInfo;
